import {RequestStatus} from '@/typedef'

export const checkIsLoading = (
  status: RequestStatus | Array<RequestStatus>
) => {
  if (Array.isArray(status))
    return status.some(stat => stat === RequestStatus.REQUESTED)
  return status === RequestStatus.REQUESTED
}
